<template>
    <div class="d-flex align-items-center">
        <div v-if="userType == 1" class="finance-nav-c d-none d-sm-block"> 
            <div class="d-flex align-items-start"> 
                <img src="@/assets/imgs/icon-wallet.svg" style="width:23px"/>
                <div v-if="hidePrice2 == 'false'"> 
                    <p class="fs-6 fw-light">Cobros pendientes</p>
                    <p class="small fw-light">Últimos 60 días</p>
                    <p v-if="currencyInter != currencyLocal" class="text-green"><b>{{currencyLocal}} {{totalDLocal}} | {{currencyInter}} {{totalDInter}}</b> <i class="las la-eye" @click="showHidePrices(2)"></i></p>
                    <p v-else class="text-green"><b>{{currencyLocal}} {{totalDLocal}}</b> <i class="las la-eye" @click="showHidePrices(2)"></i></p>
                </div>
                <div v-if="hidePrice2 == 'true'"> 
                    <p class="fs-6 fw-light">Cobros pendientes</p>
                    <p class="small fw-light">Últimos 60 días</p>
                    <p v-if="currencyInter != currencyLocal" class="text-green"><b>{{currencyLocal}} *** | {{currencyInter}} ***</b> <i class="las la-low-vision" @click="showHidePrices(2)"></i></p>
                    <p v-else class="text-green"><b>{{currencyLocal}} ***</b> <i class="las la-low-vision" @click="showHidePrices(2)"></i></p>
                </div>
            </div>
        </div>
        <div v-if="userType == 1" class="d-none d-sm-block p-relative" style="width: 241px"> 
            <div class="d-flex justify-content-start align-items-center cont-plan-nav text-center gap-1">
                <div style="width: 74px"> 
                    <p v-if="userPlan == 1" class="m-0 text-center small text-capitalize">Plan<br>{{name1}}</p>
                    <p v-if="userPlan == 2" class="m-0 text-center small text-capitalize">Plan<br>{{name2}}</p>
                    <p v-if="userPlan == 3" class="m-0 text-center small text-capitalize">Plan<br>Ilimitado</p>
                    <p v-if="userPlan == 4" class="m-0 text-center small text-capitalize">Plan<br>{{name4}}</p>
                </div>
                <div class="border-start h-100">
                    <p class="m-0 details">Citas Recurrentes: {{ totalUsesRecurrent }}</p>
                    <p class="m-0 details">Citas Únicas: {{ totalUsesServices }}</p>
                    <p class="m-0 details">Venta de Talleres: {{ totalUsesWorkShops }}</p>
                    <p v-if="userPlan != 3" class="m-0 details"><b>Citas Totales: {{ totalUses }} de <span class="text-blue">{{ planUses }}</span></b></p>
                    <p v-if="userPlan == 3" class="m-0 details"><b>Citas Totales: {{ totalUses }} de <span class="text-blue"><i class="las la-infinity"></i></span></b></p>
                </div>
            </div>  
        </div>
        <p v-if="userType == 1 && !canRecruitCheck" class="d-none d-sm-none m-0 me-2">
            <install-app show="nav"></install-app>
        </p>
        <p class="m-0">
            <img v-if="userType == 1 && !canRecruitCheck" src="@/assets/imgs/icon-config.svg" class="d-block d-sm-none" @click="openConfig()" style="width:35px"/>
        </p>
        <!-- <i v-if="userType == 1" class="las la-cog fs-3 p-1 pt-0 pb-0 d-block d-sm-none" @click="openConfig()"></i> -->
        <div class="d-none d-sm-block pointer" @click="showNotifications">
            ¡Hola {{userName}}!
        </div>
        <div class="hellow-avatar" @click="showNotifications">
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" v-if="countUnread > 0">
                {{countUnread}}
            </span>
            <img class="img-fluid" width="34" height="34" style="width: 34px;" v-if="userAvatar == '@/assets/imgs/user-img-small.png'" src="@/assets/imgs/user-img-small-gradient.png" />
            <img class="img-fluid" width="34" height="34" v-else :src="userAvatar" style="width: 34px;" />
            
        </div>    
    </div>
    
    <!-- ends soport -->
    
    <div class="notifications-nav" v-if="showHideNotifications">
        <div class="d-flex mode-recruit" v-if="showRecluterOption">
            <div class="form-check form-switch p-2 pt-0 pb-0 m-0">
                <input class="form-check-input" type="checkbox" id="canRecruit" @click="changeCanRecruit()" :checked="canRecruitCheck">
                <label class="form-check-label" for="canRecruit">Modo Reclutador</label>
            </div>
        </div>
        <div class="list-group" v-if="this.userType == '1'">
            <router-link :to="{name: 'courses'}" class="list-group-item list-group-item-action pointer m-0 pt-3 pb-3"><i class="las la-graduation-cap s-22 text-gradient-green"></i> Talleres Vendidos y Vivos</router-link>
        </div>
        <div class="list-group" v-if="this.userType == '1'">
            <router-link :to="{name: 'my-courses'}" class="list-group-item list-group-item-action pointer m-0 pt-3 pb-3"><i class="las la-graduation-cap s-22 text-gradient-green"></i> Mis Talleres Adquiridos</router-link>
        </div>
        <div class="list-group" v-if="this.userType == '1'">
            <router-link :to="{name: 'questions'}" class="list-group-item list-group-item-action pointer m-0 pt-3 pb-3"><i class="las la-comments s-22 text-gradient-green"></i> Preguntas</router-link>
        </div>
        <div class="list-group" v-if="this.userType == '2'">
            <router-link :to="{name: 'my-account' }" class="list-group-item list-group-item-action pointer m-0 pt-3 pb-3"><i class="las la-tools s-22 text-gradient-green"></i> Configuración</router-link>
        </div> 
        <div class="list-group">
            <li @click="logout()" class="list-group-item list-group-item-action pointer m-0 pt-3 pb-3"><i class="las la-sign-out-alt s-22 text-gradient-green"></i> Salir</li>
        </div>
        <hr class="mb-2">  
        <h5 class="text-muted m-0 p-2 text-gradient-green"><i class="las la-bell"></i> Notificaciones</h5>
        <div class="list-group" v-if="countUnread > 0">
            <div v-for="b in notifications" :key="b.count">
                <router-link v-if="b.userType == 1 && b.typeSms == 1 && b.userread == 0" @click="markNotificationRead(b.id)" :to="{name: 'questions'}" :id="'noti'+b.count" class="list-group-item list-group-item-action list-group-item-secondary" aria-current="true">
                    <div class="d-flex w-100 justify-content-between">
                        <small class="text-muted">{{b.date}}</small>
                    </div>
                    <p class="mb-1 text-muted" v-if="b.typeSms == 1"><i class="las la-question-circle"></i> {{b.sms}}</p>    
                </router-link>
                <router-link v-if="b.userType == 1 && b.typeSms == 1 && b.userread == 1" :to="{name: 'questions'}" :id="'noti'+b.count" class="list-group-item list-group-item-action" aria-current="true">
                    <div class="d-flex w-100 justify-content-between">
                        <small class="text-muted">{{b.date}}</small>
                    </div>
                    <p class="mb-1 text-muted" v-if="b.typeSms == 1"><i class="las la-question-circle"></i> {{b.sms}}</p>    
                </router-link>
                <router-link v-if="b.userType == 2 && b.typeSms == 1 && b.userread == 0" @click="markNotificationRead(b.id)" :to="{name: 'answers'}" :id="'noti'+b.count" class="list-group-item list-group-item-action list-group-item-secondary" aria-current="true">
                    <div class="d-flex w-100 justify-content-between">
                        <small class="text-muted">{{b.date}}</small>
                    </div>
                    <p class="mb-1 text-muted" v-if="b.typeSms == 1"><i class="las la-question-circle"></i> {{b.sms}}</p>    
                </router-link>
                <router-link v-if="b.userType == 2 && b.typeSms == 1 && b.userread == 1" :to="{name: 'answers'}" :id="'noti'+b.count" class="list-group-item list-group-item-action" aria-current="true">
                    <div class="d-flex w-100 justify-content-between">
                        <small class="text-muted">{{b.date}}</small>
                    </div>
                    <p class="mb-1 text-muted" v-if="b.typeSms == 1"><i class="las la-question-circle"></i> {{b.sms}}</p>    
                </router-link>
            </div>
        </div>
        <div class="text-center" v-if="countUnread == 0">
            <p class="text-muted">No tienes notificaciones</p>
        </div>
    </div>
</template>
<script>
import installApp from '@/components/public/home/install-app.vue'
import axios from "axios";
export default { 
    name: "userHello",
    data(){
        return{
            userName: '',
            userAvatar: '',
            dataReceiver: '',
            notifications: [],
            showHideNotifications: false,
            showHideNotifications2: false,
            countUnread: 0,
            userType: 0,
            showRecluterOption: false,
            canRecruit: 0, 
            canRecruitCheck: false,
            userPlan: '',
            name1: '',
            name2: '',
            name3: '',
            name4: '',
            totalUsesRecurrent: 0,
            totalUsesServices: 0,
            totalUsesWorkShops: 0,
            totalUses: 0,
            planUses: 0,
            userCountry: '',
            localZone: '',
            currencyInter: '',
            currencyLocal: '',
            period: '',
            totalDInter: '',
            totalDLocal: '',
            totalFInter: '',
            totalFLocal: '',
            hidePrice1: 'false',
            hidePrice2: 'false',
        }
    },
    components:{ 
        installApp
    },
    mounted: function () {
        if(localStorage.getItem('hidePrice2')){
            this.hidePrice2 = localStorage.getItem('hidePrice2');
        }
        if(localStorage.getItem('hidePrice1')){
            this.hidePrice1 = localStorage.getItem('hidePrice1');
        }
        if(localStorage.getItem('token')){
            if(localStorage.getItem('token') != ''){
                var data = JSON.parse(localStorage.getItem('userData'));
                this.userType = data.userType;
                this.userPlan = data.userPlan;
                this.totalUses = data.totalUses;
                this.userCountry = data.userCountry
                this.planUses = data.planUses;
                this.canRecruit = data.canRecruit;
                this.localZone = data.timezone;
                
                if(this.$route.name  == 'my-tools' || this.$route.name  == 'my-tools-recruiter' || this.$route.name  == 'homeLang'){
                    if(this.canRecruit == '1'){
                        if(localStorage.getItem('recruitCheck')){
                            this.canRecruitCheck = localStorage.getItem('recruitCheck');
                        }
                        if(this.canRecruitCheck == 'true'){
                            this.$router.push({ name: 'my-tools-recruiter'});
                            this.canRecruitCheck = true;
                        }else{
                            if(this.userType == 1){
                                this.$router.push({ name: 'my-tools'});
                            }else if(this.userType == 2){
                                this.$router.push({ name: 'homeLang'});
                            }
                            this.canRecruitCheck = false;
                        }
                        this.showRecluterOption = true;

                    }
                }
               
            }
        }
        var data = JSON.parse(localStorage.getItem('userData'));
        let n = data.userFirstName;
        n = n.split(' ');
        this.userName = n[0];  
        this.userAvatar = data.userImg; 
        this.dataReceiver = localStorage.getItem('token');
        this.findPlans();
        this.findNotifications();
        this.listBilling();
        var fnotifications = this;
        setInterval(function () { fnotifications.findNotifications(), fnotifications.listBilling() }, 300000);
        setInterval(function () { fnotifications.reloadPlanUses() }, 3000);
    },
    methods:{
        showHidePrices(val){
            if(val == 1){
                if(this.hidePrice1 == 'false'){
                    this.hidePrice1 = 'true';
                    localStorage.setItem('hidePrice1', this.hidePrice1);
                }else{
                    this.hidePrice1 = 'false';
                    localStorage.setItem('hidePrice1', this.hidePrice1);
                }
            }else if(val == 2){
                if(this.hidePrice2 == 'false'){
                    this.hidePrice2 = 'true';
                    localStorage.setItem('hidePrice2', this.hidePrice2);
                }else{
                    this.hidePrice2 = 'false';
                    localStorage.setItem('hidePrice2', this.hidePrice2);
                }
            }

        },
        reloadPlanUses(){
            var data = JSON.parse(localStorage.getItem('userData'));
            this.userType = data.userType;
            this.userPlan = data.userPlan;
            this.totalUses = data.totalUses;
            this.userCountry = data.userCountry
            this.planUses = data.planUses;
            this.totalUsesRecurrent = data.totalUsesRecurrent;
            this.totalUsesServices = data.totalUsesServices;
            this.totalUsesWorkShops = data.totalUsesWorkShops;
            this.canRecruit = data.canRecruit;
        },
        async findPlans(){      
            var payload = {
                action: 'find-plans',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver, 
                userCountry: this.userCountry,     
                isRegister: false
            }       
            await axios.post('/index.php', payload).then(result => {
                this.name1 = result.data.name1;
                this.name2 = result.data.name2;
                this.name3 = result.data.name3;
                this.name4 = result.data.name4;  
            })
            .catch(error => {
               
            })     
        },
        openConfig(){
            this.$router.push({ name: 'sidebar-start-mobile'});
        },
        logout(){
            
            localStorage.removeItem('token');
            localStorage.removeItem('userData');
            if(this.actualPage == '/'){
                location.reload();
            }else{
                this.$router.push({ name: 'login-apk'});
            }
        },
        async findNotifications(){   
            this.notifications = []; 
            var payload = {
                action: 'find-notifications',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver, 
            }       
            await axios.post('/index.php', payload).then(result => { 
                this.countUnread = 0;
                this.notifications = result.data;
                let sum = 0;
                Object.keys(result.data).forEach(key => {
                    if(result.data[sum].userread == 0){
                        this.countUnread++;
                    }
                    sum++;
                });            
            })
            .catch(error => {
               
            })     
        },
        showNotifications(){
            if(this.showHideNotifications == false){
                this.showHideNotifications = true;
                this.showHideNotifications2 = false;
            }else{
                this.showHideNotifications = false;
                this.showHideNotifications2 = false;
            }
        },
        
        async markNotificationRead(val){   
            this.notifications = []; 
            var payload = {
                action: 'mark-notifications',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                id: val    
            }       
            await axios.post('/index.php', payload).then(result => {      
            })
            .catch(error => {
               
            })     
        },
        changeCanRecruit(){
            if(this.canRecruitCheck == false){
                this.canRecruitCheck = true;  
            }else{
                this.canRecruitCheck = false;
            }
            localStorage.setItem('recruitCheck', JSON.stringify(this.canRecruitCheck)); 

            if(this.canRecruitCheck == true){
                this.$router.push({ name: 'my-tools-recruiter'});
            }else{

                if(this.userType == 1){
                    this.$router.push({ name: 'my-tools'});
                }else if(this.userType == 2){
                    this.$router.push({ name: 'homeLang'});
                }
            }
        },
        async listBilling(){ 
            var payload = {
                    action: 'find-billing-short',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    dataReceiver: this.dataReceiver,
                    timezone: this.localZone
                } 
                await axios.post('/index.php', payload)
                .then(result => { 
                    this.currencyInter = result.data.currencyInter;
                    this.currencyLocal = result.data.currencyLocal;
                    this.period = result.data.month1 + ' - ' + result.data.month2;
                    this.totalDInter = result.data.totalDInter;
                    this.totalDLocal = result.data.totalDLocal;
                    this.totalFInter = result.data.totalFInter;
                    this.totalFLocal = result.data.totalFLocal;
                    if(this.currencyInter == this.currencyLocal){
                        this.totalDLocal = (parseInt(this.totalDLocal) + parseInt(this.totalDInter));
                        this.totalFLocal = (parseInt(this.totalFLocal) + parseInt(this.totalFInter));
                    }
                })
                
                .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                return;

            })
        }, 
    }
}
</script>
<style scoped>
.hellow-avatar{
    max-width: 39px;
    margin-left: 10px;
    border-radius: 50%;
    border: 3px solid;
    position: relative;
    cursor: pointer;
    height: 39px;
}
.hellow-avatar img{
    border-radius: 50%;
    width: 100%;
}
.notifications-nav{
    position: fixed;
    background: #fff;
    width: 300px;
    max-height: calc(100% - 132px);
    top: 55px;
    right: 43px;
    box-shadow: 0 0 10px rgb(0 0 0 / 56%) !important;
    border: 1px solid #ddd;
    overflow: auto;
    padding: 0px;
    border-radius: 5px;
    z-index: 500000;
}
@media screen and (max-width: 1024px) {
.notifications-nav{
    right: 0;
}
}
@media screen and (max-width: 720px) {
.notifications-nav{
    right: 0;
    width: 100%;
    /* height: calc(100% - 105px); */
    max-height: calc(100% - 105px);
}
}

.mode-recruit{
    justify-content: left;
    margin-left: 38px;
    padding: 13px;
    color: #212529;
}
.form-check-input:checked {
    background-color: #4CAF50 !important;
    border-color: #4CAF50 !important;
}

.cont-plan-nav{
    width: 230px;
    background: #00c7a2;
    margin: 0px;
    color: #004193;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    padding: 7px;
    position: absolute;
    top: 0px;
    height: 55px;

}
.cont-plan-nav div p:first-child{
    font-size: 13px;
}
.cont-plan-nav p.details{
    font-size: 11px !important;
    color: #fff;
    font-weight: 500;
    padding: 0px 5px;
    text-align: left;
    line-height: 12px;
    transform: translateY(-5px);
}
.cont-plan-nav p.details:last-child{
    transform: translateY(-3px);
}
.cont-plan-nav p.details b{
    font-weight: 600;
}
.finance-nav-c{
    width: 302px;
    font-size: 14px;
    margin-top: -2px;
}
.finance-nav-c div > i{
    font-size: 27px;
}
.finance-nav-c p:first-child{
    font-size: 13px !important;
}
.finance-nav-c p{
    font-size: 10px;
    line-height: 12px;
    margin: 0;
}
.finance-nav-c p:last-child{
    font-size: 13px;
    transform: translateY(3px);
}
.finance-nav-c p i{
    font-size: 23px;
    cursor: pointer;
    margin-left: 5px;
    position: absolute;
    margin-top: -6px;
    opacity: 0.7;
}
.finance-nav-c p i:hover{
    opacity: 1;
}

</style>
